import React, { useState, useEffect } from "react";
import instance from "../utils/axiosInstance";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { ethers } from "ethers";
import contractJson from "./Contract_3.json";

const SellModal = ({ nftAddress, tokenId, nftId, onClose, onSold, tokenURI }) => {
  const [price, setPrice] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [approving, setApproving] = useState(false);
  const [needsApproval, setNeedsApproval] = useState(false);

  const contractABI = contractJson.abi;
  const MARKET_NFT_CONTRACT = process.env.REACT_APP_NFT_CONTRACT_ADDRESS?.toLowerCase();
  const provider = new ethers.JsonRpcProvider(process.env.REACT_APP_RPC_URL);

  const checkApproval = async (nftAddress, tokenId) => {
    try {
      const contract = new ethers.Contract(nftAddress, contractABI, provider);
      const approved = await contract.getApproved(tokenId);
      return approved.toLowerCase() === MARKET_NFT_CONTRACT;
    } catch (err) {
      console.error("Approve 확인 실패:", err);
      return false;
    }
  };

  useEffect(() => {
    if (nftAddress?.toLowerCase() !== MARKET_NFT_CONTRACT) {
      setNeedsApproval(true);
      checkApproval(nftAddress, tokenId).then(result => setIsApproved(result));
    } else {
      setNeedsApproval(false);
      setIsApproved(true);
    }
  }, [nftAddress, tokenId]);

  const handleApprove = async () => {
    if (!password) {
      alert("지갑 비밀번호를 입력해주세요.");
      return;
    }
    try {
      setApproving(true);
      await instance.post(
        "/order/approve",
        { nftAddress, tokenId, password },
        { withCredentials: true }
      );
      alert("승인 완료!");
      setIsApproved(true);
    } catch (err) {
      console.error("승인 실패:", err);
      alert(err.response?.data?.message || "NFT 승인 실패");
    } finally {
      setApproving(false);
    }
  };

  const handleSell = async () => {
    if (!price || !password) {
      alert("가격과 지갑 비밀번호를 입력해주세요.");
      return;
    }
    try {
      setLoading(true);
      const now = Math.floor(Date.now() / 1000);
      const expiration = now + 3600 * 24 * 365 * 10; // 10년 후

      await instance.post(
        "/order/create",
        {
          nftAddress,
          tokenURI,
          tokenId,
          nftId,
          price,
          password,
          isLazy: false,
          expiration,
        },
        { withCredentials: true }
      );

      alert("판매 등록 완료!");
      onSold();
      onClose();
    } catch (err) {
      console.error("판매 등록 실패:", err);
      alert("판매 등록 중 오류 발생");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>판매 등록</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <TextField
            label="판매 가격 (ETH)"
            type="number"
            inputProps={{ step: "0.0001", min: "0" }}
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            fullWidth
          />
          <TextField
            label="지갑 비밀번호"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />

          {needsApproval && !isApproved && (
            <Typography variant="body2" color="text.secondary">
              해당 NFT는 마켓플레이스 컨트랙트에 판매 권한이 없습니다. 먼저 승인해주세요.
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ mt: 2 }}>
        {needsApproval && !isApproved ? (
          <Button
            onClick={handleApprove}
            variant="contained"
            color="warning"
            disabled={approving}
          >
            {approving ? <CircularProgress size={20} /> : "NFT 승인"}
          </Button>
        ) : (
          <Button
            onClick={handleSell}
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "판매 등록"}
          </Button>
        )}
        <Button onClick={onClose} variant="outlined" color="inherit">
          취소
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SellModal;


